export enum ColumnType {
	EMPTY,
	RESULT,
	TIP,
}